import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';

interface DefaultValueExpressionConfig {
  sourceField: string;
  mappings: Record<string, string>;
}

const subscriptions = new WeakMap<FormlyFieldConfig, Subscription>();

export const defaultValueExpressionExtension: FormlyExtension = {
  onPopulate(field: FormlyFieldConfig): void {
    const config = (field as any).defaultValueExpression as DefaultValueExpressionConfig | undefined;
    if (!config?.sourceField || !config?.mappings) {
      return;
    }

    // Clean up any previous subscription (in case onPopulate runs again)
    subscriptions.get(field)?.unsubscribe();

    const sourceControl = field.form?.root?.get(config.sourceField);
    if (!sourceControl) {
      return;
    }

    const subscription = sourceControl.valueChanges
      .pipe(startWith(sourceControl.value))
      .subscribe(value => {
        const mappedValue = config.mappings[value];
        if (mappedValue !== undefined && field.formControl) {
          field.formControl.setValue(mappedValue);
        }
      });

    subscriptions.set(field, subscription);

    // Register cleanup on field destroy
    const existingOnDestroy = field.hooks?.onDestroy;
    field.hooks = {
      ...field.hooks,
      onDestroy: (f: FormlyFieldConfig) => {
        subscriptions.get(f)?.unsubscribe();
        subscriptions.delete(f);
        existingOnDestroy?.(f);
      },
    };
  },
};
